var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpb-lead"},[_vm._t("top"),_c('Lead',_vm._b({scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._t("title")]},proxy:true}],null,true)},'Lead',{ ..._vm.data, ..._vm.options },false)),_vm._t("bottom")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }